module.exports = __webpack_public_path__ + "1dc344d863e6cedd511d2e0a8473dc5c.svg";